{
  "1 fax number": "1 fax number",
  "1 tag": "1 tag",
  "200 page limit": "200 page limit",
  "<0>Are you sure you want to delete </0><1>{template?.name ?? 'this template'}</1><2>?</2>": "<0>Are you sure you want to delete </0><1>{template?.name ?? 'this template'}</1><2>?</2>",
  "Access Off/On": "Access Off/On",
  "Add Contact": "Add Contact",
  "Add Documents": "Add Documents",
  "Add Tag": "Add Tag",
  "Adding Contact": "Adding Contact",
  "Adjust filter to find faxes more than 13 months old.": "Adjust filter to find faxes more than 13 months old.",
  "All": "All",
  "All Templates": "All Templates",
  "All locations {{count}}_one": "All locations {{count}}",
  "All locations {{count}}_other": "All locations {{count}}",
  "Allow Weave to contact me about my response": "Allow Weave to contact me about my response",
  "An unknown error occurred": "An unknown error occurred",
  "Apply": "Apply",
  "Apply changes to this template": "Apply changes to this template",
  "Archive": "Archive",
  "Archive Fax": "Archive Fax",
  "Archived": "Archived",
  "Are You Sure?": "Are You Sure?",
  "Are you sure you want to archive this fax?": "Are you sure you want to archive this fax?",
  "Are you sure you want to delete this contact?": "Are you sure you want to delete this contact?",
  "Are you sure you want to delete this fax?": "Are you sure you want to delete this fax?",
  "Are you sure you want to unarchive this fax?": "Are you sure you want to unarchive this fax?",
  "Are you sure?": "Are you sure?",
  "Back": "Back",
  "Beta": "Beta",
  "Block": "Block",
  "Block Sender": "Block Sender",
  "Blocked": "Blocked",
  "Bulk selection menu": "Bulk selection menu",
  "Calculating Size": "Calculating Size",
  "Cancel": "Cancel",
  "Cannot delete unsaved contact": "Cannot delete unsaved contact",
  "Cannot revoke fax location access": "Cannot revoke fax location access",
  "Change Cover Sheet": "Change Cover Sheet",
  "Clear": "Clear",
  "Click Here": "Click Here",
  "Click on one to dive in.": "Click on one to dive in.",
  "Close bulk select": "Close bulk select",
  "Confirm & Save Template": "Confirm & Save Template",
  "Contact Blocked": "Contact Blocked",
  "Contact Created": "Contact Created",
  "Contact Deleted": "Contact Deleted",
  "Contact Unblocked": "Contact Unblocked",
  "Contact Updated": "Contact Updated",
  "Continue": "Continue",
  "Continue and...": "Continue and...",
  "Cover Sheet": "Cover Sheet",
  "Cover Sheet Disabled for this Fax": "Cover Sheet Disabled for this Fax",
  "Coversheet must be assigned to at least one location": "Coversheet must be assigned to at least one location",
  "Create '{{tagName}}' Tag": "Create '{{tagName}}' Tag",
  "Create Fax template": "Create Fax template",
  "Create Tag": "Create Tag",
  "Create Template": "Create Template",
  "Create a brand new cover sheet with the fax builder.": "Create a brand new cover sheet with the fax builder.",
  "Create a new fax cover sheet": "Create a new fax cover sheet",
  "Creating New Fax...": "Creating New Fax...",
  "Daily": "Daily",
  "Delete": "Delete",
  "Delete Contact": "Delete Contact",
  "Delete Draft": "Delete Draft",
  "Delete Fax": "Delete Fax",
  "Delete Template": "Delete Template",
  "Deleting Contact": "Deleting Contact",
  "Delivered": "Delivered",
  "Delivery Report Downloaded": "Delivery Report Downloaded",
  "Delivery Status": "Delivery Status",
  "Deselect all": "Deselect all",
  "Direction": "Direction",
  "Don't ask me again": "Don't ask me again",
  "Done": "Done",
  "Download": "Download",
  "Draft": "Draft",
  "Draft Deleted": "Draft Deleted",
  "Draft Not Found": "Draft Not Found",
  "Draft not found": "Draft not found",
  "Drag and drop or click to upload documents": "Drag and drop or click to upload documents",
  "Duplicate": "Duplicate",
  "Duplicate recipients are not allowed": "Duplicate recipients are not allowed",
  "Edit": "Edit",
  "Edit Contact": "Edit Contact",
  "Enable Cover Sheet": "Enable Cover Sheet",
  "End Date": "End Date",
  "End date must be after the start date": "End date must be after the start date",
  "Enter a title": "Enter a title",
  "Error": "Error",
  "Error Archiving Fax": "Error Archiving Fax",
  "Error Blocking Contact": "Error Blocking Contact",
  "Error Deleting Draft": "Error Deleting Draft",
  "Error Deleting Fax": "Error Deleting Fax",
  "Error Downloading Delivery Report": "Error Downloading Delivery Report",
  "Error Downloading Fax": "Error Downloading Fax",
  "Error Downloading Fax and Report": "Error Downloading Fax and Report",
  "Error Previewing Delivery Report": "Error Previewing Delivery Report",
  "Error Previewing Fax": "Error Previewing Fax",
  "Error Previewing Fax and Report": "Error Previewing Fax and Report",
  "Error Sending Fax": "Error Sending Fax",
  "Error Tagging Fax": "Error Tagging Fax",
  "Error Unarchiving Fax": "Error Unarchiving Fax",
  "Error Unblocking Contact": "Error Unblocking Contact",
  "Error Untagging Fax": "Error Untagging Fax",
  "Error adding contact": "Error adding contact",
  "Error adding recipient": "Error adding recipient",
  "Error creating fax": "Error creating fax",
  "Error creating template.": "Error creating template.",
  "Error deleting draft.": "Error deleting draft.",
  "Error deleting template.": "Error deleting template.",
  "Error duplicating template.": "Error duplicating template.",
  "Error editing template.": "Error editing template.",
  "Error generating summary": "Error generating summary",
  "Error granting access": "Error granting access",
  "Error rendering contact data!": "Error rendering contact data!",
  "Error revoking access": "Error revoking access",
  "Error saving draft.": "Error saving draft.",
  "Error sending fax": "Error sending fax",
  "Error submitting feedback. Please try again.": "Error submitting feedback. Please try again.",
  "Error updating email preferences.": "Error updating email preferences.",
  "Error updating template.": "Error updating template.",
  "Error uploading files": "Error uploading files",
  "Error uploading {{count}} files_one": "Error uploading {{count}} files",
  "Error uploading {{count}} files_other": "Error uploading {{count}} files",
  "Every Time": "Every Time",
  "Every good fax has a cover sheet. Select which kind of cover sheet you would like to proceed with to build your new fax message.": "Every good fax has a cover sheet. Select which kind of cover sheet you would like to proceed with to build your new fax message.",
  "Export": "Export",
  "Failed to Create Contact": "Failed to Create Contact",
  "Failed to Delete Contact": "Failed to Delete Contact",
  "Failed to Update Contact": "Failed to Update Contact",
  "Failed to archive faxes": "Failed to archive faxes",
  "Failed to delete fax": "Failed to delete fax",
  "Failed to delete faxes": "Failed to delete faxes",
  "Failed to mark as read": "Failed to mark as read",
  "Failed to mark as unread": "Failed to mark as unread",
  "Failed to retrieve fax info. Please try again.": "Failed to retrieve fax info. Please try again.",
  "Failed to send fax. Please try again.": "Failed to send fax. Please try again.",
  "Failed to submit feedback. Please try again.": "Failed to submit feedback. Please try again.",
  "Failed to submit rating. Please try again.": "Failed to submit rating. Please try again.",
  "Failed to tag faxes": "Failed to tag faxes",
  "Failed to unarchive faxes": "Failed to unarchive faxes",
  "Fax": "Fax",
  "Fax & Confirmation": "Fax & Confirmation",
  "Fax Archived": "Fax Archived",
  "Fax Confirmation": "Fax Confirmation",
  "Fax Confirmation Only": "Fax Confirmation Only",
  "Fax Contacts": "Fax Contacts",
  "Fax Deleted": "Fax Deleted",
  "Fax Downloaded": "Fax Downloaded",
  "Fax History": "Fax History",
  "Fax Inbox": "Fax Inbox",
  "Fax Message": "Fax Message",
  "Fax Message & Confirmation": "Fax Message & Confirmation",
  "Fax Message Only": "Fax Message Only",
  "Fax Number": "Fax Number",
  "Fax Settings": "Fax Settings",
  "Fax Tagged": "Fax Tagged",
  "Fax Unarchived": "Fax Unarchived",
  "Fax Untagged": "Fax Untagged",
  "Fax Updates": "Fax Updates",
  "Fax and Report Downloaded": "Fax and Report Downloaded",
  "Fax archived successfully!": "Fax archived successfully!",
  "Fax confirmation pages": "Fax confirmation pages",
  "Fax deleted successfully!": "Fax deleted successfully!",
  "Fax has been sent successfully": "Fax has been sent successfully",
  "Fax location not found": "Fax location not found",
  "Fax pages not found": "Fax pages not found",
  "Fax unarchived successfully!": "Fax unarchived successfully!",
  "Faxes Archived": "Faxes Archived",
  "Faxes Date Range": "Faxes Date Range",
  "Faxes Deleted": "Faxes Deleted",
  "Faxes Tagged": "Faxes Tagged",
  "Faxes Unarchived": "Faxes Unarchived",
  "Faxing is better with contacts. That's just fax.": "Faxing is better with contacts. That's just fax.",
  "Feedback (Optional)": "Feedback (Optional)",
  "Feedback submitted. Thank you!": "Feedback submitted. Thank you!",
  "File too large. Max file size is {{amount}}": "File too large. Max file size is {{amount}}",
  "Filter faxes": "Filter faxes",
  "Final rendering failed for {{contacts}}": "Final rendering failed for {{contacts}}",
  "Finalize": "Finalize",
  "Forward": "Forward",
  "From {{sender}}": "From {{sender}}",
  "From:": "From:",
  "Grant Access": "Grant Access",
  "If you leave now your work may not be saved. To come back to this later select \"Save as Draft\". Weave will keep your draft for 90 days.": "If you leave now your work may not be saved. To come back to this later select \"Save as Draft\". Weave will keep your draft for 90 days.",
  "Inbound": "Inbound",
  "Incoming": "Incoming",
  "Invalid Contact": "Invalid Contact",
  "Invalid fax number": "Invalid fax number",
  "Invalid fax number in recipient list": "Invalid fax number in recipient list",
  "Invalid fax number. Please reach out to support to set this up.": "Invalid fax number. Please reach out to support to set this up.",
  "Invalid file type": "Invalid file type",
  "Invalid location id": "Invalid location id",
  "Is this helpful?": "Is this helpful?",
  "Loading...": "Loading...",
  "Location": "Location",
  "Location Access": "Location Access",
  "Manage your fax settings.": "Manage your fax settings.",
  "Mark Read": "Mark Read",
  "Mark Unread": "Mark Unread",
  "Mark summary as helpful": "Mark summary as helpful",
  "Mark summary as not helpful": "Mark summary as not helpful",
  "Marked as read": "Marked as read",
  "Marked as unread": "Marked as unread",
  "Media not found.": "Media not found.",
  "Monthly": "Monthly",
  "More Actions": "More Actions",
  "More actions": "More actions",
  "Name": "Name",
  "Name Your New Template": "Name Your New Template",
  "New": "New",
  "New Contact": "New Contact",
  "New Fax": "New Fax",
  "New Template Title": "New Template Title",
  "New fax messages": "New fax messages",
  "Next": "Next",
  "No Cover Sheet": "No Cover Sheet",
  "No Phone Number": "No Phone Number",
  "No contacts to show": "No contacts to show",
  "No drafts to show": "No drafts to show",
  "No fax numbers are available for this location — none may be set up, or all are privately assigned to other users. Manage access in ": "No fax numbers are available for this location — none may be set up, or all are privately assigned to other users. Manage access in ",
  "No fax selected.": "No fax selected.",
  "No faxes to show": "No faxes to show",
  "No locations data": "No locations data",
  "Nothing to see here...yet.": "Nothing to see here...yet.",
  "Only {{amount}} files can be uploaded at once": "Only {{amount}} files can be uploaded at once",
  "Optional": "Optional",
  "Other Filters": "Other Filters",
  "Outbound": "Outbound",
  "Outgoing": "Outgoing",
  "Page {{page}}": "Page {{page}}",
  "Phone Numbers and Porting": "Phone Numbers and Porting",
  "Photo": "Photo",
  "Please select a from number": "Please select a from number",
  "Please select at least one recipient": "Please select at least one recipient",
  "Please share details about what you found valuable in the Weave AI Fax Overview.": "Please share details about what you found valuable in the Weave AI Fax Overview.",
  "Please share details about your issues with the Weave AI Fax Overview.": "Please share details about your issues with the Weave AI Fax Overview.",
  "Preview / Print": "Preview / Print",
  "Preview Fax": "Preview Fax",
  "Preview Not Available": "Preview Not Available",
  "Provide Additional Feedback": "Provide Additional Feedback",
  "Rating submitted. Thank you!": "Rating submitted. Thank you!",
  "Read": "Read",
  "Read Status": "Read Status",
  "Receive fax updates by email": "Receive fax updates by email",
  "Received": "Received",
  "Recipient": "Recipient",
  "Recipient Email": "Recipient Email",
  "Recipient number": "Recipient number",
  "Relay Status": "Relay Status",
  "Retry": "Retry",
  "Retrying": "Retrying",
  "Revoke Access": "Revoke Access",
  "Save": "Save",
  "Save As Draft": "Save As Draft",
  "Save Contact": "Save Contact",
  "Save Template": "Save Template",
  "Save as new template": "Save as new template",
  "Second Name": "Second Name",
  "See less tags": "See less tags",
  "See more tags": "See more tags",
  "Select": "Select",
  "Select Cover Sheet": "Select Cover Sheet",
  "Select Location": "Select Location",
  "Select Recipients": "Select Recipients",
  "Select Template": "Select Template",
  "Select This Template": "Select This Template",
  "Select a Cover Sheet Type": "Select a Cover Sheet Type",
  "Select a Location": "Select a Location",
  "Select all": "Select all",
  "Select the location you are creating a contact for.": "Select the location you are creating a contact for.",
  "Select the location you are sending this fax from.": "Select the location you are sending this fax from.",
  "Selected {{count}} of {{total}}_one": "Selected {{count}} of {{total}}",
  "Selected {{count}} of {{total}}_other": "Selected {{count}} of {{total}}",
  "Send Date": "Send Date",
  "Send Fax": "Send Fax",
  "Send Time": "Send Time",
  "Sender": "Sender",
  "Sender number": "Sender number",
  "Sending Fax": "Sending Fax",
  "Sent": "Sent",
  "Sent from {{name}}": "Sent from {{name}}",
  "Sent from {{number}}": "Sent from {{number}}",
  "Skip": "Skip",
  "Skip Cover Sheet": "Skip Cover Sheet",
  "Something went wrong. Please try again.": "Something went wrong. Please try again.",
  "Start Cover Sheet": "Start Cover Sheet",
  "Start Date": "Start Date",
  "Start New": "Start New",
  "Start by adding a recipient!": "Start by adding a recipient!",
  "Start date must be before the end date": "Start date must be before the end date",
  "Status": "Status",
  "Submit": "Submit",
  "Successfully updated email preferences.": "Successfully updated email preferences.",
  "Summary": "Summary",
  "Summary is not available": "Summary is not available",
  "Tag": "Tag",
  "Tag Settings": "Tag Settings",
  "Tags": "Tags",
  "Template Preview": "Template Preview",
  "Template Title": "Template Title",
  "Template created successfully.": "Template created successfully.",
  "Template deleted successfully.": "Template deleted successfully.",
  "Template duplicated successfully.": "Template duplicated successfully.",
  "Template edited successfully.": "Template edited successfully.",
  "Template preview is not available.": "Template preview is not available.",
  "Template updated successfully.": "Template updated successfully.",
  "This Fax has an uploaded cover sheet attached": "This Fax has an uploaded cover sheet attached",
  "This action is irreversible. Are you sure you want to delete this draft?": "This action is irreversible. Are you sure you want to delete this draft?",
  "This action is irreversible. Are you sure you want to delete this fax?": "This action is irreversible. Are you sure you want to delete this fax?",
  "This contact is already selected": "This contact is already selected",
  "To {{recipient}}": "To {{recipient}}",
  "To:": "To:",
  "Total upload size cannot exceed {{amount}}MB": "Total upload size cannot exceed {{amount}}MB",
  "Type": "Type",
  "Type two or more characters to search faxes.": "Type two or more characters to search faxes.",
  "Unable to archive fax!": "Unable to archive fax!",
  "Unable to delete existing coversheet!": "Unable to delete existing coversheet!",
  "Unable to delete fax!": "Unable to delete fax!",
  "Unable to delete uploaded coversheet!": "Unable to delete uploaded coversheet!",
  "Unable to export fax history!": "Unable to export fax history!",
  "Unable to preview fax!": "Unable to preview fax!",
  "Unable to save draft.": "Unable to save draft.",
  "Unable to unarchive fax!": "Unable to unarchive fax!",
  "Unarchive": "Unarchive",
  "Unarchive Fax": "Unarchive Fax",
  "Unblock": "Unblock",
  "Unblock Sender": "Unblock Sender",
  "Undelivered": "Undelivered",
  "Unknown": "Unknown",
  "Unknown Contact": "Unknown Contact",
  "Unknown Location": "Unknown Location",
  "Unread": "Unread",
  "Update Type": "Update Type",
  "Updated at {{formattedDate}}": "Updated at {{formattedDate}}",
  "Updating Contact": "Updating Contact",
  "Upload": "Upload",
  "Upload Cover Sheet": "Upload Cover Sheet",
  "Upload My Own": "Upload My Own",
  "Upload Pages": "Upload Pages",
  "Uploading": "Uploading",
  "Uploading Cover Sheet...": "Uploading Cover Sheet...",
  "Uploading...": "Uploading...",
  "Use This Template": "Use This Template",
  "Use another document as your fax cover": "Use another document as your fax cover",
  "View": "View",
  "Want to upload your own cover sheet? Jump right into uploading your fax documents.": "Want to upload your own cover sheet? Jump right into uploading your fax documents.",
  "Weave AI Fax Overview": "Weave AI Fax Overview",
  "Weekly": "Weekly",
  "Which locations will have access to this template?": "Which locations will have access to this template?",
  "With Access {{count}}_one": "With Access {{count}}",
  "With Access {{count}}_other": "With Access {{count}}",
  "Without Access  {{count}}_one": "Without Access  {{count}}",
  "Without Access  {{count}}_other": "Without Access  {{count}}",
  "You're in the archives.": "You're in the archives.",
  "You've reached the end of your faxes.": "You've reached the end of your faxes.",
  "Your location does not have a fax number to send from. Please reach out to support to set this up.": "Your location does not have a fax number to send from. Please reach out to support to set this up.",
  "delivery status": "delivery status",
  "read status": "read status",
  "relay status": "relay status",
  "send date": "send date",
  "{{count}} fax numbers_one": "{{count}} fax numbers",
  "{{count}} fax numbers_other": "{{count}} fax numbers",
  "{{count}} tags_one": "{{count}} tags",
  "{{count}} tags_other": "{{count}} tags",
  "{{value}} / {{max}} MB (large files may have a hard time sending)": "{{value}} / {{max}} MB (large files may have a hard time sending)"
}
